import { render } from "./FacultyCourseLoad.vue?vue&type=template&id=73210109"
import script from "./FacultyCourseLoad.vue?vue&type=script&lang=js"
export * from "./FacultyCourseLoad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__